import { combineReducers, Reducer } from 'redux';
import { connectRouter } from 'connected-react-router';
import articlesReducer from '../article/ArticlesReducer';
import { StoreState } from './StoreState';
import menuReducer from './../menu/MenuReducer';
import { History } from 'history';
import LocationState = History.LocationState;

export const createRootReducer: (history: History<LocationState>) => Reducer<StoreState> = history => combineReducers({
    menu: menuReducer,
    articles: articlesReducer,
    router: connectRouter(history),
});



// WEBPACK FOOTER //
// ./src/store/RootReducer.ts